import type { Transaction, TransactionDirection, TransactionStatus } from '../../types';
import { MOCK_TRANSACTIONS } from '../../lib/mockData';
import { request } from '../api/client';

let transactions = [...MOCK_TRANSACTIONS];

export interface HistoryFilter {
  direction?: TransactionDirection | 'all';
  status?: TransactionStatus | 'all';
  query?: string;
}

export const transactionService = {
  list(filter: HistoryFilter = {}) {
    return request('/transactions', () => {
      let rows = transactions;
      if (filter.direction && filter.direction !== 'all') rows = rows.filter((t) => t.direction === filter.direction);
      if (filter.status && filter.status !== 'all') rows = rows.filter((t) => t.status === filter.status);
      if (filter.query) {
        const q = filter.query.toLowerCase();
        rows = rows.filter((t) => t.counterparty.toLowerCase().includes(q) || t.reference.toLowerCase().includes(q));
      }
      return rows;
    });
  },

  get(id: string) {
    return request(`/transactions/${id}`, () => transactions.find((t) => t.id === id));
  },

  prepend(tx: Transaction) {
    transactions = [tx, ...transactions];
    return transactions;
  },

  /** CSV export string for the export screen. */
  exportCsv(rows: Transaction[]) {
    return request('/transactions/export', () => {
      const header = 'Reference,Date,Counterparty,Direction,Category,Amount,Currency,Fee,Status';
      const lines = rows.map((t) =>
        [t.reference, t.date, t.counterparty, t.direction, t.category, t.amount, t.currency, t.fee, t.status].join(','),
      );
      return [header, ...lines].join('\n');
    }, { delay: 800 });
  },
};
